import Box from './Box'

const SandboxPage = () => {
  return <Box></Box>
}

export default SandboxPage
